module.exports = __webpack_public_path__ + "img/106.6df18ff9.png";